module.exports = __webpack_public_path__ + "img/logo.8d41b4d8.png";